import { useQuery } from "react-query";
import { playlistBusinessTypesApi } from "frontend/src/api/playlist-business-types";
import { playlistBusinessTypesCacheKey } from "./shared";
export var usePlaylistBusinessTypes = function (request) {
    return useQuery([playlistBusinessTypesCacheKey, request], function () {
        return playlistBusinessTypesApi.getMany(request);
    });
};
